<template>
  <div>
    <!-- Description -->
    <md-field :class="{
        'md-error': $v.subscriptionsModel.description.$error && $v.subscriptionsModel.description.$invalid,
        'md-valid': !$v.subscriptionsModel.description.$error && !$v.subscriptionsModel.description.$invalid}">
      <label>{{ $t("ticket.create.description") }}</label>
      <md-input v-model.trim="$v.subscriptionsModel.description.$model"></md-input>
      <slide-y-down-transition>
        <md-icon class="error" v-show="$v.subscriptionsModel.description.$error && $v.subscriptionsModel.description.$invalid">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.subscriptionsModel.description.$error && !$v.subscriptionsModel.description.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Select teams -->
    <md-field :class="{'md-valid': !$v.subscriptionsModel.teamId.$error && !$v.subscriptionsModel.teamId.$invalid}">
      <label>{{ $t("ticket.create.team") }}</label>
      <md-select v-model.trim="$v.subscriptionsModel.teamId.$model" name="team" id="team">
        <md-option v-for="team in listTeams" :value="team.id" :key="team.id">{{team.name}}</md-option>
      </md-select>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.subscriptionsModel.teamId.$error && !$v.subscriptionsModel.teamId.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Quantity -->
    <md-field :class="{
        'md-error': $v.subscriptionsModel.quantity.$error && $v.subscriptionsModel.quantity.$invalid,
        'md-valid': !$v.subscriptionsModel.quantity.$error && !$v.subscriptionsModel.quantity.$invalid}">
      <label>{{ $t("ticket.create.quantity") }}</label>
      <md-input type="number" v-model.trim="$v.subscriptionsModel.quantity.$model"></md-input>
      <slide-y-down-transition>
        <md-icon class="error" v-show="$v.subscriptionsModel.quantity.$error && $v.subscriptionsModel.quantity.$invalid">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="!$v.subscriptionsModel.quantity.$error && !$v.subscriptionsModel.quantity.$invalid">done</md-icon>
      </slide-y-down-transition>
    </md-field>
    <!-- Due date -->
    <md-datepicker md-immediately v-model="$v.subscriptionsModel.dueDate.$model" :class="{
      'md-error': $v.subscriptionsModel.dueDate.$error && $v.subscriptionsModel.dueDate.$invalid,
      'md-valid': !$v.subscriptionsModel.dueDate.$error && !$v.subscriptionsModel.dueDate.$invalid}">
      <label>{{$t('ticket.create.dueDate')}}</label>
    </md-datepicker>
    <!-- Only One Game -->
    <md-checkbox v-model="$v.subscriptionsModel.onlyOneGame.$model">
      {{$t('ticket.create.onlyOneGame')}}
    </md-checkbox>
    <br>
    <md-button @click="createSubscriptions" :disabled="submittedSubscriptions" class="md-info" :class="{ disabled: submittedSubscriptions }">
      {{ $t("ticket.create.create") }}
    </md-button>
  </div>
</template>

<script>
import { required, number } from "vuelidate/lib/validators";
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex'; 

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      submittedSubscriptions: false,
      subscriptionsModel: {
        description: "",
        teamId: null,
        quantity: null,
        dueDate: null,
        onlyOneGame: false
      },
    }
  },
  computed: {
    ...mapState({
      listTeams: state => state.StuffModule.teams
    })
  },
  async mounted() {
    await this.$store.dispatch("teamsGet")
  },
  methods: {
    async createSubscriptions() {
      this.$v.subscriptionsModel.$touch();
      if (!this.$v.subscriptionsModel.$invalid) {
        this.submittedSubscriptions = true;
        const modelSubscription = Object.assign({}, this.subscriptionsModel)

        if (modelSubscription.dueDate != null) {
          const dueDateFormat = `${moment(modelSubscription.dueDate, "DD/MM/YYYY").format('YYYY-MM-DD')}T00:00:00.000`
          modelSubscription.dueDate = `${dueDateFormat}`
        }
        modelSubscription.quantity = Number(modelSubscription.quantity)
        
        await this.$store.dispatch('generateSubscriptionLot', modelSubscription)
        this.$notify({
          message: this.$t(`notifications.ticket.create`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.submittedSubscriptions = false;
        this.$router.push("/list/ticketera");
      }
    },
  },
  validations: {
    subscriptionsModel: {
      description: {
        required
      },
      teamId: {},
      quantity: {
        required
      },
      dueDate: {},
      onlyOneGame: {}
    }
  }
}
</script>

<style>

</style>